module.exports = __webpack_public_path__ + "media/images/profile/career-info-bfc9373f896ad0fe4868d052efd6d249.svg";